<template>
  <div class="autocomplete">
    <b-input-group>
      <b-form-input
        @keydown.down="onArrowDown"
        @keydown.up="onArrowUp"
        @keydown.enter="onEnter"
        type="text"
        v-model="search"
        @input="onChange"
        size="sm"
      />
      <b-input-group-append>
        <b-button variant="info" @click="clear" size="sm">Clear</b-button>
      </b-input-group-append>
    </b-input-group>
    <ul v-show="isOpen" class="autocomplete-results">
      <li class="loading autocomplete-result" v-if="isLoading">
        Loading results...
      </li>
      <li
        v-for="(result, i) in results"
        :key="result.key"
        @click="setResult(result)"
        class="autocomplete-result"
        :class="{ 'is-active': i === arrowCounter }"
      >
        {{ result.value }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Autocomplete',
  props: {
    isAsync: {
      type: Boolean,
      required: false,
      default: false,
    },
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      search: '',
      minSearchLength: 3,
      results: [],
      isOpen: false,
      isLoading: false,
      arrowCounter: -1,
    };
  },
  watch: {
    items: function(value, oldValue) {
      if (
        !(
          value.length === oldValue.length &&
          value.sort().every(function(value, index) {
            return value === oldValue.sort()[index];
          })
        )
      ) {
        this.results = value;
        this.isLoading = false;
      }
    },
  },
  methods: {
    clear(event) {
      event.preventDefault();
      this.arrowCounter = -1;
      this.search = '';
      this.setResult({ key: null, value: null });
    },
    onArrowDown() {
      if (!this.isOpen) {
        this.isOpen = true;
      }
      if (this.arrowCounter < this.results.length) {
        this.arrowCounter++;
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter--;
      }
    },
    onEnter(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.arrowCounter === -1) {
        return;
      }
      this.setResult(this.results[this.arrowCounter]);
      this.arrowCounter = -1;
    },
    setResult(result) {
      this.$emit('select', result);
      this.search = result.value;
      this.isOpen = false;
    },
    onChange() {
      if (this.search.length < this.minSearchLength) return;
      this.$emit('input', this.search);

      this.isOpen = true;

      if (this.isAsync) {
        this.isLoading = true;
      } else {
        this.filterResults();
      }
    },
    filterResults() {
      this.results = this.items.filter((item) => item.toLowerCase().indexOf(this.search.toLowerCase()) > -1);
    },
    handleClickOutside(evt) {
      if (!this.$el.contains(evt.target)) {
        this.isOpen = false;
        this.arrowCounter = -1;
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  destroyed() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>

<style scoped>
.autocomplete {
  position: relative;
}

.autocomplete-results {
  padding: 0;
  margin: 0;
  border: 1px solid #eeeeee;
  height: 120px;
  overflow: auto;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #fff;
  z-index: 100;
}

.autocomplete-result {
  list-style: none;
  text-align: left;
  padding: 4px 10px;
  cursor: pointer;
}

.autocomplete-result:hover,
.is-active {
  background-color: #555555;
  color: white;
}
</style>
